import { api } from "./client";

/** Staff Web Push endpoints (Authentication group — device registration is
 *  session plumbing, the same reasoning that puts the portal's device_tokens
 *  beside its auth). See docs in the Xano push/* endpoints. */

export interface PushBadge {
  /** The Dock badge: actionable leads + accepted-but-unconverted quotes. */
  count: number;
  /** new + to_schedule + overdue_consultations. */
  leads_actionable: number;
  new_leads: number;
  to_schedule: number;
  overdue_consultations: number;
  accepted_quotes: number;
  /** PERSONAL: scheduled leads booked since this viewer last opened the
   *  Pipeline. Feeds the Leads nav badge only — never the Dock icon. */
  unseen_bookings: number;
  /** PERSONAL: this viewer's unread letters (read receipts). Included in
   *  `count`, so the Dock icon is per-person too. */
  letters_unread: number;
  /** PERSONAL: this viewer's unread chat messages (per-job read state,
   *  same formula as /staff/chat/jobs). Included in `count`. */
  chat_unread: number;
}

export interface SubscribeBody {
  endpoint: string;
  p256dh: string;
  auth_secret: string;
  ua_label?: string;
}

export function subscribe(body: SubscribeBody): Promise<{ ok: boolean; id: number }> {
  return api.post("auth", "push/subscribe", { body, auth: true });
}

export function unsubscribe(endpoint: string): Promise<{ ok: boolean }> {
  return api.post("auth", "push/unsubscribe", { body: { endpoint }, auth: true });
}

export function badge(): Promise<PushBadge> {
  return api.get("auth", "push/badge", { auth: true });
}

/** Stamp the caller's bookings-seen watermark (clears unseen_bookings). */
export function bookingsSeen(): Promise<{ ok: boolean }> {
  return api.post("auth", "push/bookings-seen", { auth: true });
}
